"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsPageLayout = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./permissions-page-layout.scss");
function PermissionsPageLayout(props) {
    var _a, _b, _c;
    const { className, children } = props;
    const classNames = (0, classnames_1.default)('permissions-page-layout', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: 'permissions-page-layout__header' },
            " ", (_a = children[0]) !== null && _a !== void 0 ? _a : ''),
        react_1.default.createElement("div", { className: 'permissions-page-layout__main' },
            " ", (_b = children[1]) !== null && _b !== void 0 ? _b : ''),
        react_1.default.createElement("div", { className: 'permissions-page-layout__actions' },
            " ", (_c = children[2]) !== null && _c !== void 0 ? _c : '')));
}
exports.PermissionsPageLayout = PermissionsPageLayout;
//# sourceMappingURL=PermissionsPageLayout.js.map